import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const ModernCard = ({ 
  children, 
  className = '', 
  gradient = false, 
  glow = false,
  themeColor = 'blue',
  paddingClass = 'p-6',
  borderClass = 'border'
}) => {
  const { isDarkMode } = useTheme();
  const getThemeGradient = (color) => {
    const darkGradients = {
      blue: 'from-blue-500/10 to-blue-600/5',
      green: 'from-green-500/10 to-green-600/5',
      purple: 'from-purple-500/10 to-purple-600/5',
      orange: 'from-orange-500/10 to-orange-600/5',
      red: 'from-red-500/10 to-red-600/5',
      indigo: 'from-indigo-500/10 to-indigo-600/5',
      pink: 'from-pink-500/10 to-pink-600/5',
      teal: 'from-teal-500/10 to-teal-600/5',
      yellow: 'from-yellow-500/10 to-yellow-600/5'
    };
    
    const lightGradients = {
      blue: 'from-blue-50 to-blue-100',
      green: 'from-green-50 to-green-100',
      purple: 'from-purple-50 to-purple-100',
      orange: 'from-orange-50 to-orange-100',
      red: 'from-red-50 to-red-100',
      indigo: 'from-indigo-50 to-indigo-100',
      pink: 'from-pink-50 to-pink-100',
      teal: 'from-teal-50 to-teal-100',
      yellow: 'from-yellow-50 to-yellow-100'
    };
    
    const gradients = isDarkMode ? darkGradients : lightGradients;
    return gradients[color] || gradients.blue;
  };

  const getThemeGlow = (color) => {
    const glows = {
      blue: 'shadow-blue-500/20',
      green: 'shadow-green-500/20',
      purple: 'shadow-purple-500/20',
      orange: 'shadow-orange-500/20',
      red: 'shadow-red-500/20',
      indigo: 'shadow-indigo-500/20',
      pink: 'shadow-pink-500/20',
      teal: 'shadow-teal-500/20',
      yellow: 'shadow-yellow-500/20'
    };
    return glows[color] || glows.blue;
  };

  const baseClasses = `
    backdrop-blur-sm rounded-xl ${paddingClass}
    transition-all duration-300 hover:scale-[1.02]
    ${isDarkMode ? `${borderClass} border-white/10 bg-gray-900/50` : `${borderClass} border-gray-200 bg-white/95`}
  `;

  const gradientClasses = gradient ? `bg-gradient-to-br ${getThemeGradient(themeColor)}` : '';
  const glowClasses = glow ? `shadow-2xl ${getThemeGlow(themeColor)}` : 'shadow-lg shadow-black/20';

  return (
    <div className={`${baseClasses} ${gradientClasses} ${glowClasses} ${className}`}>
      {children}
    </div>
  );
};

export default ModernCard;